import { useTheme } from "@emotion/react";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import "../../App.css";
import ImageWithShimmer from "../ImageWithShimmer";
import Promotions from "./Promotions";
import HomeSubSection from "./SubSection";

const NewHome = () => {
  // console.log("userGeolocation", userGeolocation);
  const theme = useTheme();

  const [featureGame, setFeatureGames] = useState();
  const [allGames, setAllGames] = useState(null);
  const [menuList, setMenuList] = useState(null);
  const [allData, setAllData] = useState(null);

  const [categoryList, setCategoryList] = useState(null);

  // const [packages, setPackages] = useState(null);

  useEffect(() => {
    getHomePageData();
  }, []);

  const getHomePageData = async () => {
    // dispatch(setLoading(true));
    let data = {
      userid: null,
    };

    let url = `https://api-stage.spinsagacasino.com:5000/api/casino/homepagecategory`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const json = await response.json();

      if (json?.status === "success") {
        setAllData(json?.data);
        setAllGames(json?.data?.games);

        // data has to be shown in category
        setCategoryList(json.data?.categorylist);
        setFeatureGames(json?.data?.featuregames);
      } else {
        // Handle non-success status here if needed
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  //created new function to pass category name to nested game component

  function createSlug(text) {
    return text
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-");
  }

  function scrollToTarget(id, offset = 100) {
    var targetElement = document.getElementById(id);
    if (targetElement) {
      var scrollPosition = targetElement.offsetTop - offset;
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }

  const onChangeCategory = (item) => {
    scrollToTarget(item.category); //category name);
  };

  const getCategoryCount = (category) => {
    if (allData) {
      const { countbymenu } = allData;
      if (countbymenu[category] !== undefined) {
        return `${countbymenu[category]}`;
      } else {
        return 0;
      }
    }
  };

  //   console.log('akk',allGames)
  const imageCDN = "https://cdn.spinsagacasino.com:5000/";
  return (
    <>
      <main className="inner-body">
        <Box>
          <Promotions showSmallShimmer={false} />
        </Box>
        <Grid
          container
          spacing={{ xs: 1, sm: 1, md: 2 }}
          style={{
            display: "flex",
            overflowX: "auto",

            flexWrap: "nowrap",
          }}
        >
          {featureGame &&
            featureGame.map((game, index) => (
              <Grid
                item
                xs={4}
                sm={6}
                md={2.4}
                style={{ flex: "none" }}
                key={index}
                id={game.menu}
              >
                <Card>
                  <CardActionArea onClick={() => {}}>
                    <ImageWithShimmer
                      src={
                        game?.ext_url
                          ? `${game?.ext_url}`
                          : `${imageCDN}${game.game_creative}`
                      }
                      alt={game.game_name}
                    />
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
        </Grid>

        <section className="button_scroll">
          <Typography
            className="btn_group c_scroll"
            sx={{
              backgroundColor: theme.palette.custom.black_light,
            }}
            component="div"
          >
            {categoryList &&
              categoryList.map((item) => (
                <Button
                  key={item.cat_id}
                  size="small"
                  sx={{
                    backgroundColor: theme.palette.custom.dark_light_btn,
                    color: theme.palette.custom.white_gray,
                    border: theme.palette.custom.btn_border,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px", // Adjust spacing between icon and text
                  }}
                  onClick={() => onChangeCategory(item)}
                >
                  <img
                    src={`${imageCDN}${item.categoryIcon}`}
                    alt={item.category}
                    style={{ width: 24, height: 24 }}
                  />
                  {item.category}
                </Button>
              ))}
          </Typography>
        </section>

        {allGames &&
          Object.keys(allGames).map((category, index) => {
            return (
              <>
                <Typography
                  sx={{
                    color: theme.palette.custom.white_gray,
                    // fontSize: "1.25rem", // increase font size
                    padding: "12px 0", // add vertical padding
                    fontWeight:'700',
                    fontSize:'18px'
                  }}
                  key={category}
                >
                  {category}
                </Typography>

                <Grid
                  container
                  spacing={{ xs: 1, sm: 1, md: 2 }}
                  style={{
                    //  overflowX: "scroll",
                    display: "flex",
                    overflowX: "auto",
                    flexWrap: "nowrap",
                  }}
                >
                  {allGames[category].map((game, index) => (
                    <Grid
                      item
                      xs={4}
                      sm={6}
                      md={2.4}
                      key={index}
                      id={game.category}
                      style={{ flex: "none" }}
                    >
                      <Card>
                        <CardActionArea
                          style={{ position: "relative" }}
                          onClick={() => {}}
                        >
                          <ImageWithShimmer
                            src={
                              game?.ext_url?.includes("https:")
                                ? `${game?.ext_url}`
                                : `${imageCDN}${game.game_creative}`
                            }
                            alt={game.game_name}
                          />
                        </CardActionArea>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </>
            );
          })}
      </main>
      <HomeSubSection/>
    </>
  );
};

export default NewHome;
